import React, { ReactNode } from 'react';
import { Badges } from 'src/client/components/ui/Badges';

type Props = {
  badges?: ReactNode[];
  className?: string;
};

export const CardBadgeList = (props: Props) => {
  if (!props.badges?.length) return null;

  return (
    <div className={props.className}>
      <Badges>{props.badges}</Badges>
    </div>
  );
};
